import React from 'react';
import PropTypes from 'prop-types';
import DatabaseListContainer from 'components/DatabaseList/DatabaseListContainer';

const propTypes = {
  databases: PropTypes.instanceOf(Array),
  id: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
};

const defaultProps = {
  databases: [],
};

export function UnstyledDatabasesTab({ databases, id, service }) {
  return <DatabaseListContainer service={service} databases={databases} instanceId={id} />;
}

UnstyledDatabasesTab.propTypes = propTypes;
UnstyledDatabasesTab.defaultProps = defaultProps;

export default UnstyledDatabasesTab;
